import React, { Component } from 'react'
import {/* List, ListItem, ListItemIcon, ListItemText, Typography, Link,  */Hidden} from '@material-ui/core';
import IconC from './../components/_IconC'

class FormMultibuscador extends Component {
    /* constructor(props) {
        super(props)
    } */

    render() {
        const GetTabsLinks = () => {
            const {items, active, client} = this.props
            
            return (
                <ul className="tabsLinks" >
                    {items.map((navLink, i) =>
                        <li className={`tab ${navLink.module === active ? 'active' : ''}`} key={i} >
                      
                            <a href={`${client.urlSite}/${navLink.link}`} className="tabLink">
                                <span className="icon iconModule">
                                    <IconC icon={navLink.icon} alt={navLink.moduleName} className="custom_icon" />
                                </span>
                                <Hidden smDown><span className="tabText">{navLink.moduleName}</span></Hidden>
                            </a>
                        </li>
                    )}
                </ul>
            )
        }
        const GetTabsContent = (props) =>{
            return (
                <div className="tabsContent">
                    {props.content}
                </div>
            )
        }
        return (
            <div className="formMultibuscador" >
                <GetTabsLinks />
                <GetTabsContent content={this.props.content} />
            </div>
        )
    }
}

export default FormMultibuscador